import AgentStore from "@/stores/agentLogin";
import http, { postApi } from "@/utils/http";
import { Message } from "@arco-design/web-react";
import axios from "axios";
// 登录接口
export async function loginApi(data: any): Promise<any> {
  return postApi(`/user/login`, data, {}, {Device: "web_client"});
}
export async function agentLogin(data: any): Promise<any> {
  const res = await axios.post(`/api/v1/video/auth/login`, data, {
    headers: {
      Aid: process.env.REACT_APP_AID,
      Device: "web_client",
    },
  });
  return res.data;
}

// 客户切换列表
export async function getAgentList(params: any): Promise<any> {
  try {
    const token = AgentStore.agent_info.token;
    const res = await axios.get(`/api/v1/video/auth/teams`, {
      headers: {
        Aid: process.env.REACT_APP_AID,
        Token: token || undefined,
      },
      params,
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      Message.error("Token 已过期，请重新登录");
      window.location.reload();
    }
  }
}
// 一键登录
export async function agentOneLogin(data: any): Promise<any> {
  const token = AgentStore.agent_info.token;
  const res = await axios.post(`/api/v1/video/auth/one/login`, data, {
    headers: {
      Aid: process.env.REACT_APP_AID,
      Device: "web_client",
      Token: token || undefined,
    },
  });
  return res.data;
}
